export function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages === 0) return null;

  // Функция, которая возвращает массив страниц для отображения с "..."
  const getPages = () => {
    const pages = [];

    if (totalPages <= 5) {
      // Если страниц мало — показываем все
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      // Если страниц много — показываем первые, последние и текущие +-2
      pages.push(1);

      if (currentPage > 4) pages.push('left-ellipsis');

      let startPage = Math.max(2, currentPage - 2);
      let endPage = Math.min(totalPages - 1, currentPage + 2);

      for (let i = startPage; i <= endPage; i++) pages.push(i);

      if (currentPage < totalPages - 3) pages.push('right-ellipsis');

      pages.push(totalPages);
    }

    return pages;
  };

  const pages = getPages();

  return (
    <div className="flex space-x-1 justify-center mt-4 text-sm">
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(1)}
        className={`px-3 py-1 rounded ${currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`}
      >
        {"<<"}
      </button>
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className={`px-3 py-1 rounded ${currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`}
      >
        {"<"}
      </button>

      {pages.map((page, i) => {
        if (page === "left-ellipsis" || page === "right-ellipsis") {
          return <span key={i} className="px-2 py-1">...</span>;
        }
        return (
          <button
            key={i}
            onClick={() => onPageChange(page)}
            className={`px-3 py-1 rounded ${page === currentPage ? "bg-blue-700 text-white" : "bg-blue-100 hover:bg-blue-200"}`}
          >
            {page}
          </button>
        );
      })}

      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className={`px-3 py-1 rounded ${currentPage === totalPages ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`}
      >
        {">"}
      </button>
      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(totalPages)}
        className={`px-3 py-1 rounded ${currentPage === totalPages ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`}
      >
        {">>"}
      </button>
    </div>
  );
}
